"use client";

import { useMemo } from "react";
import {
  selectTimelineSnapCandidates,
  selectTimelineSnappedSectionColor,
  selectTimelineTrackHighlightGradient,
} from "./timeline-root-selectors";
import type { SnapCandidate } from "./timeline-root-types";
import type { ParsedTimeline } from "./timeline-types";

export interface UseTimelineSnapCandidatesInput {
  collapsedSections: Set<number>;
  parsed: ParsedTimeline | null;
}

export interface UseTimelineRootSnapModelInput {
  snapCandidates: SnapCandidate[];
  snappedPeriodIndex: number | null;
}

export interface TimelineRootSnapModel {
  snapCandidates: SnapCandidate[];
  snappedSectionColor: string;
  trackHighlightGradient: string;
}

export function useTimelineSnapCandidates({
  collapsedSections,
  parsed,
}: UseTimelineSnapCandidatesInput): SnapCandidate[] {
  return useMemo(
    () =>
      selectTimelineSnapCandidates({
        collapsedSections,
        parsed,
      }),
    [collapsedSections, parsed],
  );
}

export function useTimelineRootSnapModel({
  snapCandidates,
  snappedPeriodIndex,
}: UseTimelineRootSnapModelInput): TimelineRootSnapModel {
  const snappedSectionColor = useMemo(
    () =>
      selectTimelineSnappedSectionColor({
        snapCandidates,
        snappedPeriodIndex,
      }),
    [snapCandidates, snappedPeriodIndex],
  );

  const trackHighlightGradient = useMemo(
    () =>
      selectTimelineTrackHighlightGradient({
        sectionColor: snappedSectionColor,
      }),
    [snappedSectionColor],
  );

  return {
    snapCandidates,
    snappedSectionColor,
    trackHighlightGradient,
  };
}
